import script from "./QuestionView.vue?vue&type=script&setup=true&lang=js"
export * from "./QuestionView.vue?vue&type=script&setup=true&lang=js"

import "./QuestionView.vue?vue&type=style&index=0&id=6920fa03&scoped=true&lang=css"

import exportComponent from "C:\\Users\\alexg\\Desktop\\martech\\whappy-app-front-vue-v2\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-6920fa03"]])

export default __exports__